import {GET_TESTIMONIALS} from './actionTypes'

const initialState = {
  myTestimonials: '',
  // isLoading: false,
  // hasError: false,
  fulfilled: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TESTIMONIALS:
      return {
        ...state,
        myTestimonials: action.payload,
        fulfilled: true,
      }

    default:
      return state
  }
};
